import { createReducer, Action, on } from '@ngrx/store';
import {
    createFormGroupState,
    onNgrxForms,
    updateGroup,
    onNgrxFormsAction,
    SetValueAction,
    wrapReducerWithFormStateUpdate,
    validate,
} from 'ngrx-forms';
import { requiredTrue } from 'ngrx-forms/validation';
import { ResetDataSavedAction } from './actions';
import { ITermsConditionsState, TermsConditionsModel } from './state';

const formName = 'termsAndConditions';

const defaultState: ITermsConditionsState = {
    form: createFormGroupState(formName, new TermsConditionsModel()),
};

const validateTermsConditions = updateGroup<TermsConditionsModel>({
    readAllInformationAgreement: validate(requiredTrue)
});

const reducer = createReducer(
    defaultState,
    onNgrxForms(),
    onNgrxFormsAction(SetValueAction, (state, _action) => {
        return state;
    }),
    on(ResetDataSavedAction, (state) => {
        return {
            ...state,
            dataSaved: false
        }
    })
);

const editTermsConditionsVerificationDataFormState = wrapReducerWithFormStateUpdate(
    reducer,
    s => s.form,
    validateTermsConditions
)

export function termsConditionsReducer(state: any | undefined, action: Action) {
    return editTermsConditionsVerificationDataFormState(state, action);
}
